export async function primeSSLConnection(mqttUrl, context = 'MQTT') {
    try {
      const httpsUrl = mqttUrl.replace('wss://', 'https://').replace('/mqtt', '');
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);
      
      await fetch(httpsUrl, {
        method: 'HEAD',
        mode: 'no-cors',
        signal: controller.signal,
        cache: 'no-cache'
      });
      
      clearTimeout(timeoutId);
      await new Promise(resolve => setTimeout(resolve, 100));
      
      return true;
    } catch (error) {
      console.warn(`SSL priming failed for ${context}, continuing anyway:`, error.message);
      return false;
    }
  }